import { omit } from 'ramda';
import {
  EExtendsOptions,
  EPreciseFilterNames,
  EPreciseFilterValues,
  TPreciseFiltersState,
} from '../../../types/redux/preciseFilters';

export const handleRadioChange = (
  filterValue: EPreciseFilterValues,
  preciseFiltersState: TPreciseFiltersState,
  filterName: EPreciseFilterNames,
): TPreciseFiltersState => {
  /**
   * Если выбрали в радио фильтре "Не выбрано" - удаляем ключ из объекта со значениями фильтров
   */
  if (String(filterValue) === EExtendsOptions.Reset) {
    return omit([filterName], preciseFiltersState);
  }

  return {
    ...preciseFiltersState,
    [filterName]: [String(filterValue)],
  };
};
